import {
  PATH_NAME_SEARCH,
  PATH_NAME_SEARCH_TAG,
  PATH_NAME_SEARCH_TAG_GROUP,
} from '@/common/resources/router.const'

export default [
  // {
  //   path: 'category/:id',
  //   name: PATH_NAME_CATEGORY_SEARCH,
  //   components: {
  //     bodyContent: () => import(/* webpackChunkName "categorySearch" */'@/pages/list/Category')
  //   },
  //   props: true
  // },
  {
    path: 'search',
    name: PATH_NAME_SEARCH,
    alias: '/search/search.html',
    components: {
      searchContent: () =>
        import(/* webpackChunkName: "search" */ '@/pages/search/Search'),
    },
  },
  {
    path: 'search/search_tag',
    name: PATH_NAME_SEARCH_TAG,
    alias: '/search/search_tag.html',
    components: {
      searchContent: () =>
        import(/* webpackChunkName: "search_tag" */ '@/pages/search/SearchTag'),
    },
  },
  {
    path: 'search/search_tag_group',
    name: PATH_NAME_SEARCH_TAG_GROUP,
    alias: '/search/search_tag_group.html',
    components: {
      searchContent: () =>
        import(
          /* webpackChunkName: "search_tag_group" */ '@/pages/search/SearchTagGroup'
        ),
    },
  },
]
